/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

export const offerRequestSegment = 'offer-request';
export const offerRequestStatusSegment = 'status';
export const offerRequestUpdatedSegment = 'updated';

export const offerSegment = 'offer';
export const offerAddedSegment = 'added';

export const spOfferRequestSegment = 'sp-offer-request';
export const spOfferRequestStatusSegment = 'status';
export const spOfferRequestUpdatedSegment = 'updated';

export const orderSegment = 'order';
export const orderStatusSegment = 'status';
export const orderUpdatedSegment = 'updated';

export const offerChatSegment = 'offer/chat';
export const offerChatSendMessageSegment = 'send';
export const offerChatReadMessageSegment = 'read';
export const offerChatStatusSegment = 'status';
export const offerChatStatusUpdateSegment = 'update';
export const offerChatIncomingSegment = 'incoming';

export const shipmentSplitSegment = 'shipment/split';
export const shipmentSplitOfferSegment = 'offer';
export const shipmentSplitAddedSegment = 'added';

export const shipmentTrackingSegment = 'shipment/tracking';
export const shipmentTrackingShipmentRequestSegment = 'shipment/request';
export const shipmentTrackingSavedSegment = 'saved';
export const shipmentTrackingOrderSegment = 'order'
export const shipmentTrackingSubcontractorOrderSegment = `subcontractor/${shipmentTrackingOrderSegment}`;
export const shipmentTrackingOrderStatusUpdatedSegment = 'updated';
export const shipmentTrackingOrderStatusAcceptedSegment = 'accepted';
export const shipmentTrackingOrderStatusInProgressSegment = 'in/progress';
export const shipmentTrackingOrderStatusInTransitSegment = 'in/transit';
export const shipmentTrackingOrderStatusCompletedSegment = 'completed';
export const shipmentTrackingOrderStatusDocumentsReceivedSegment = 'documents/received';
export const shipmentTrackingInvoiceSegment = 'invoice';
export const shipmentTrackingClosedSegment = 'closed';
export const shipmentTrackingGeneratedSegment = 'generated';

export const deliveryInboxSegment = 'delivery-inbox';
export const deliveryOutboxSegment = 'delivery-outbox';
export const deliveryInboxAddedSegment = 'added';
export const deliveryInboxUpdatedSegment = 'updated';
export const deliveryOutboxUpdatedSegment = 'updated';

export const timelineSegment = 'timeline';
export const timelineUpdatedSegment = 'updated';
